import { create } from 'zustand'

interface WebsiteSettingsPanelState {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  reset: () => void
}

// Controls the builder's settings panel, toggled from the header (la-cog
// button), the same arrangement useMenuSidebarStore and useFloorPlanPanelStore
// give their own pages. Open by default: the page's colours live in this panel,
// and they were previously reachable only by deselecting everything, which is
// not a gesture anybody guesses.
export const useWebsiteSettingsStore = create<WebsiteSettingsPanelState>(
  set => ({
    isOpen: true,
    setIsOpen: value => set({ isOpen: value }),
    reset: () => set({ isOpen: true })
  })
)
